<template>
  <v-row justify="center" no-gutters>
    <v-col cols="12">
      <v-row justify="center" align="end" no-gutters>
        <v-col lg="12" xl="10">
          <v-row no-gutters justify="center" align="end">
            <v-col cols="12" md="6" lg="4" class="d-flex flex-column">
              <v-img
                id="logo"
                height="160"
                contain
                :src="logo"
              ></v-img>
              <v-card id="primary-card">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <upcoming-sortition
                        id="upcoming-result"
                        :upcoming-sortition="upcomingSortition"
                        @refresh="fetchUpcomingSortition"
                      ></upcoming-sortition>
                    </v-col>
                  </v-row>
                  <v-row
                    v-for="result in results.entries.slice(0, 1)"
                    :key="result.sortition.id"
                  >
                    <v-col cols="12">
                      <h1>Winning Numbers</h1>
                      <result-display :result="result"></result-display>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              v-if="results.entries.slice(1).length > 0"
              cols="12"
              md="6"
              lg="5"
            >
              <v-card id="results-card">
                <v-card-text>
                  <result-display
                    v-for="result in results.entries.slice(1)"
                    :key="result.sortition.id"
                    :result="result"
                  >
                  </result-display>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="4" lg="3" align-self="end">
							<prizes-card
								id="prizes-card"
								v-if="showPrizes"
								:prizes="prizes"></prizes-card>
							<results-card
								class="card-results"
								v-if="showResults"
								:results-by-lottery="resultsToShow"></results-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col id="page-url" cols="12" class="text-center">
      <span>Visit our page {{ url }}</span>
    </v-col>
  </v-row>
</template>

<script>
import logo from "assets/static/img/logo/lucklotto.png";
import ResultDisplay from "./ResultDisplay.vue";
import UpcomingSortition from "./UpcomingSortition.vue";
import BaseBoard from "../BaseBoard";
import PrizesCard from "./PrizesCard.vue";
import ResultsCard from '@/homepage/components/common/ResultsCard.vue';

export default {
  name: "Board",
  extends: BaseBoard,
  components: {
		ResultsCard,
    UpcomingSortition,
    ResultDisplay,
    PrizesCard
	},
	data(){
		return {
			logo
		}
	}
};
</script>

<style scoped lang="scss">
@import "css/variables";

#primary-card {
  background-color: $orange;
}
.card-results {
	background-color: $orange;
}

::v-deep > .v-card {
  color: $brown;

  .v-card__text {
    color: inherit;
  }
}

#results-card::v-deep,
#prizes-card::v-deep {
  .v-card__title {
    font-size: 2rem;
  }
}

#results-card,
#prizes-card {
  background-color: $yellow;
}

#results-card {
  min-height: 400px;
}

#next-sortition-card {
  background-color: $orange;
}

#clover-1 {
  width: 150px;
  position: absolute;
  right: 20vw;
  top: 20vh;
  transform: rotate(-30deg);
}

#clover-2 {
  width: 100px;
  position: absolute;
  right: 80px;
  bottom: 150px;
}

#clover-3 {
  width: 100px;
  position: absolute;
  left: 80px;
  top: 50vh;
}

#dollar-1 {
  width: 150px;
  position: absolute;
  right: 10vw;
  top: 10vh;
  transform: rotate(30deg);
}

#dollar-2 {
  width: 100px;
  position: absolute;
  left: 80px;
  top: 20vh;
  transform: rotate(-30deg);
}

#dollar-3 {
  width: 100px;
  position: absolute;
  right: 5vw;
  bottom: 40vh;
  transform: rotate(-30deg);
}

#dollar-4 {
  width: 100px;
  position: absolute;
  left: 5vw;
  bottom: 20vh;
  transform: rotate(-30deg);
}

#board {
  width: 100%;
}

#page-url {
  text-transform: uppercase;
  font-weight: bold;
  font-family: "Arial";
  font-size: 1.5rem;
}
</style>
